import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import $ from "jquery";
import axios from 'axios';

class AdminNavbar extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

componentDidMount(){}

menuSelections(list_name,user_app_token,user_token){
	this.props.open_menu_page(list_name,user_app_token,user_token);
}
logoutUser(){
  let cutThis = this;
  var web_token = $('#web_token').val();
   var body = new FormData();
   body.append('web_token',web_token);
   body.append('function','logout_session');
   var url      = '';
   if(window.location.host ==="localhost:3000"){
     url = "http://localhost/bylawsindia/php/logout_utl.php";
   }else{
     url = "/php/logout_utl.php";
   }
   axios({
        method: 'POST',
        url: url,
        data: body
    })
    .then(function (res) {
      var data = res.data;
      if(data==1){
        window.location.href = '/';
      }
    })
    .catch(function (error) {
        console.log(error);
    });
}
  render() {
    return (


        <div className="col-md-2 dbg-light d-md-block sidebar p-0" id="dashboard_left_menu_card">
        		<div className="col-md-12 dashboard-logo-div"><img className="img-fluid flex-shrink-0 menu-logo" src="/assets/img/logo1.png" alt="Bylaws"/></div>
                <div className="left-sidebar p-3">
                    <ul className="nav flex-column sidebar-nav">
                        <li className="nav-item">
                            <a className="nav-link" onClick={() => this.menuSelections('calendar',this.props.user_app_token,this.props.user_token)}>Calendar</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" onClick={() => this.menuSelections('freeConsultation',this.props.user_app_token,this.props.user_token)}>Free Consultation</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" onClick={() => this.logoutUser()}>Logout</a>
                        </li>
                    </ul>
                </div>
            </div>

    );
  }
}

export default AdminNavbar;
